import {createStore, applyMiddleware} from 'redux'
import {composeWithDevTools} from 'redux-devtools-extension/developmentOnly'
import createSagaMiddleware from 'redux-saga'
import {IS_BROWSER, IS_TEST, WINDOW} from 'constants/environment'
import rootReducer from 'store/reducers'
import {rootSagas, locationActions, locationSelectors, environmentActions} from 'store/actions'

import {pick, rafThrottle} from 'utils'

// GTM
import gtmMapEvents from 'store/gtm-events/index-main'
import {createMiddleware} from 'redux-beacon'
import {logger} from 'redux-beacon/extensions/logger'
import {GoogleTagManager} from 'redux-beacon/targets/google-tag-manager'
import {offlineWeb} from 'redux-beacon/extensions/offline-web'

// Dirty global to hold ref to store so that all mount points get the same instance
let store = null
// For futire if we want to develop offiline mode (state) => isConnected
const offlineStorage = offlineWeb(() => true)
const googleTagManagerMiddleware = createMiddleware(gtmMapEvents, GoogleTagManager(), {
  logger: IS_TEST ? null: logger, // Disable logging for unit tests
  offlineStorage,
})
// const googleTagManagerMiddleware = createMiddleware(gtmEventMap, GoogleTagManager())
const sagaMiddleware = createSagaMiddleware()
const composeEnhancers = composeWithDevTools({
  name: 'MJO',
  actionCreators: locationActions,
})
const enhancer = composeEnhancers(applyMiddleware(sagaMiddleware, googleTagManagerMiddleware))

export function configureStore(initialState = {}) {
  return createStore(rootReducer, initialState, enhancer)
}

export default function getStore() {
  if (store) {
    return store
  }
  
  // dbg && console.trace('Configuring new store') // eslint-disable-line
  store = configureStore()
  
  if (IS_BROWSER && WINDOW) {
    sagaMiddleware.run(rootSagas)
    
    /*
     // Initiate a location fetch always regardless of the presence of location aware components
     const { state, locationConfirmed } = locationSelectors.getLocation(store.getState())
     
     if (!state) store.dispatch(locationActions.fetchLocation())
     else if (!locationConfirmed) {
     store.dispatch(locationActions.requestPostcodeInput())
     }
     */
    
    // Handle resize and scroll in one spot
    const pickDimensions = pick(['innerWidth', 'innerHeight'])
    const pickScroll = pick(['scrollY'])
    
    store.dispatch(environmentActions.updateWindowSize(pickDimensions(WINDOW)))
    store.dispatch(environmentActions.updateWindowScroll(pickScroll(WINDOW)))
    
    WINDOW.addEventListener(
      'resize',
      rafThrottle(() => store.dispatch(environmentActions.updateWindowSize(pickDimensions(WINDOW)))),
    )
  }
  
  return store
}



// WEBPACK FOOTER //
// ./src/store/index.js